import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="occurrence"
export default class extends Controller {
  connect() {
    // This controller can be extended in the future for additional occurrence functionality
    // Currently, DaisyUI handles the collapse functionality via CSS
  }
}
